export default __webpack_public_path__ + "static/media/defaultBg.cf051707.jpg";